import React, { useState, Component } from 'react'
import LanguagesBar from './LanguagesBar';
import { FaGithub, FaGlobe, FaTag, FaTags, FaCalendarAlt, FaCode, FaYoutube, FaArrowRight, FaArrowLeft, FaArrowCircleLeft, FaArrowAltCircleLeft, FaArrowsAltH, FaRegCaretSquareDown, FaCaretLeft, FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import ImageCarousel from './ImageCarousel';
import { useMediaQuery } from '@material-ui/core';
import { makeProjectID, makeProjectURL } from './makeURL';
import Slider from "react-slick";
import { isImage } from './utils';
import LaptopMockup from "./mockupComponents/LaptopMockup";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import remarkGfm from 'remark-gfm';


const ProjectCard = ({ contentDict }) => {

  const isMobile = useMediaQuery('(max-width: 768px)');

  const title = contentDict["title"] || "404: No Title Found";
  let finishDate = contentDict["finishDate"];
  if (finishDate) {
    const options = { year: 'numeric', month: 'long' }; // day: 'numeric'
    finishDate = finishDate.toLocaleDateString('en-US', options);
  }
  const description = contentDict["description"] || "404: No Description Found";
  const tags = contentDict["tags"] || [];
  const tools = contentDict["tools"] || null;
  const github = contentDict["github"] || null;
  const website = contentDict["website"] || null;
  const youtube = contentDict["youtube"] || null;
  const images = contentDict["images"] || [];
  const isResearch = contentDict["isResearch"] || false;
  const mainColor = contentDict["mainColor"] || 'black';

  const languagesAndLinks = (
    <div className='w-full'>
      { isResearch ? <></> : <LanguagesBar className='text-xs' languageDict={tools}/> }
      <div className='flex justify-center items-center text-dark dark:text-light font-semibold mt-2'>
        { github ?
        <button onClick={() => {window.open(github, '_blank')}} className='flex items-center rounded-md bg-light-accent dark:bg-dark-accent border border-light-accent2 hover:bg-opacity-70 m-1 p-0.5 pl-2 pr-2'><FaGithub/>&nbsp;&nbsp;GitHub</button>
        : <></>
        }
        { website ?
        <button onClick={() => {window.open(website, '_blank')}} className='flex items-center rounded-md bg-light-accent dark:bg-dark-accent border border-light-accent2 hover:bg-opacity-70  m-1 p-0.5 pl-2 pr-2'><FaGlobe/>&nbsp;&nbsp;Website</button>
        : <></>
        }
        { youtube ?
        <button onClick={() => {window.open(youtube, '_blank')}} className='flex items-center rounded-md bg-light-accent dark:bg-dark-accent border border-light-accent2 hover:bg-opacity-70  m-1 p-0.5 pl-2 pr-2'><FaYoutube/>&nbsp;&nbsp;YouTube</button>
        : <></>
        }
      </div>
    </div>
  );

  var settings = {
    // dots: true,
    infinite: true,
    // speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const slider = React.createRef();

  const sliderButtonClassName = 'absolute top-1/2 -translate-y-4 rounded-full text-dark dark:text-light bg-light-accent2 dark:bg-dark text-4xl p-1 z-20 opacity-50 hover:opacity-70';


  return (
    <div 
      id={makeProjectID(title)} 
      className='rounded-3xl bg-white dark:bg-dark-accent shadow-xl border-black border p-4 mt-4 mb-1'
    >
      <h1 className='text-xl'>{title}</h1>
      <div className='flex flex-wrap items-center font-light text-xs text-dark-accent dark:text-light-accent2'>
        <FaCalendarAlt className='mr-1'/>
        {finishDate}&nbsp;&nbsp;&middot;&nbsp;&nbsp;
        <FaTags className='mr-1'/>
        {tags.map((item, idx) => {
          return <span key={idx}>{item}{idx === tags.length-1 ? <></> : <>,&nbsp;</>}</span>;
        })}
      </div>
      <div className='w-full flex flex-col md:flex-row mt-3'>
        <div className='w-full md:w-2/5 mr-5'>
          {/* <div className='text-base'>{description}</div> */}
          <ReactMarkdown 
            children={description} 
            className='text-base'
            components={{
              a: ({children, ...props}) => <a {...props} target='_blank' className="underline hover:cursor-pointer">{children}</a>,
            }}
            remarkPlugins={remarkGfm}
            // rehypePlugins={}
          />
          { isMobile ? <></> : languagesAndLinks }
        </div>
        <div className="relative pt-3 md:pt-0 md:w-3/5 max-h-80 md:h-auto" >
          { images.length > 1 ?
            <FaAngleLeft onClick={() => slider.current.slickPrev()} className={`${sliderButtonClassName} left-0`}/>
            : null 
          }
          <Slider {...settings} ref={slider} className='px-2'>
            { 
              images.map((img, idx) => {
                return (
                  <div key={idx} className='flex items-center justify-center h-full'>
                    {isImage(img) ? (
                      // Show an image with or without a laptop/phone mockup
                      img.includes('laptop') ? (
                        <LaptopMockup screenImg={img} backGroundColor={mainColor}/>
                      ) : (
                        <img className='max-h-80 mx-auto rounded-lg' src={img} alt={`Image ${idx + 1}`} />
                      )
                    ) : (
                      // Show a video with or without a laptop/phone mockup
                      img.includes('laptop') ? (
                        <LaptopMockup screenImg={img} backGroundColor={mainColor}/>
                      ) : (
                        <video
                          src={img}
                          alt={`Video ${idx + 1}`}
                          autoPlay
                          loop
                          muted
                          className='rounded-lg'
                          controls={false} 
                          playsInline
                        />
                      )
                    )}
                  </div>
                );
              }) 
            }
          </Slider>
          { images.length > 1 ?
            <FaAngleRight onClick={() => slider.current.slickNext()} className={`${sliderButtonClassName} right-0 `}/>
            : null 
          }
        </div>
      </div>
      { isMobile ? languagesAndLinks : <></> }
        
    </div>
  )
}

export default ProjectCard
